import React from 'react';

// Full-viewport terminal container. Liquid-glass translucent surface floating
// above an animated amber ambient backdrop (defined in index.css :: body).
// Responsive across ultrawide + 4K via container-width tuning.
export default function TerminalFrame({ children }) {
  return (
    <div className="px-2 md:px-4 py-2 md:py-3">
      <div
        className="relative mx-auto md:overflow-hidden terminal-glass"
        style={{
          maxWidth: 'var(--terminal-max, 1560px)',
          borderRadius: 16
        }}
      >
        {/* Faint scanline sheen on top of the glass for depth */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
          style={{
            borderRadius: 16,
            background:
              'linear-gradient(180deg, rgba(255,255,255,0.045) 0%, rgba(255,255,255,0) 30%), linear-gradient(0deg, rgba(0,0,0,0.35) 0%, rgba(0,0,0,0) 40%)',
            mixBlendMode: 'screen'
          }}
        />
        {/* Desktop/tablet: fixed viewport height. Mobile: intrinsic height */}
        <div className="relative h-auto xl:h-[calc(100vh-24px)] w-full">{children}</div>
      </div>
    </div>
  );
}

